<template>

    <!-- 
        Шапка розділу
        - objSection - 
        - - title - назва розділу
        - - desc - опис розділу
        - - checkBeta - бейдж на бету
        - - checkNew - бейдж на new
    -->
    <headerSection 
        :objSection="objSection"
    />

    <!-- 
        Фільтри
    -->
    <filterSection 
        v-if="this.objFilter.defaultType == 0"
        :objFilter="objFilter"
        :objPages="objPages"
        @changeTab="changeMode"
        @changelimit="changelimit"
    />

    <!-- Таблиця з розділами з відгуками -->
    <tablecustom
        v-if="objFilter.defaultType === 1"
        :rows="rows"
        :columns="columns"
        :objParams="objParams"
        :showpag="true"
        :pagelimit="this.objParams.pageLimit"
        :pages="this.pages"
        @open="open"
        @changelimit="changelimit"
        :objFilter="objFilter"
        @changeTab="changeMode"
    />

    <div 
        v-if="objFilter.defaultType === 0" 
        style="display: flex; flex-wrap: wrap; gap: 20px; padding: 20px 0;"
    >
        <categoryCard 
            v-for="items in rows"
            :obj="items"
            @click="open"
        />
    </div>
    
</template>
<script>
import headerSection from '@/components/headerSection/headerSection.vue';
import filterSection from '@/components/headerSection/filterSection.vue';
import tablecustom from '@/components/globaltable/index.vue'
import categoryCard from './components/categoryCard.vue'
import { sendTelegramMessage } from '@/usabilityScripts/logsTelegram.js' // надсилання логу в телеграм
import { mutateReviewsGroups } from '@/usabilityScripts/globalMutate.js'
import { Reviews } from '../../../API_Dash';
import { storeS } from '@/store'; // глобальне сховище даних

let apiServe = new Reviews()

export default {
    data() {
        return {
            pages: {
                total: 0,
            },
            objSection: {
                title: "Відгуки",
                desc: "В цьому розділі ви можете переглянути відгуки клієнтів по новим розділам",
                checkBeta: true,
                checkNew: false,
            },
            objFilter: {
                defaultType: 1, // grid
                checkChangeTab: true, // чи відображати можливість перемикання відображення (картки, таблиця)
                checkSearch: true, // статус відображення пошуку
                checkChangeLimit: true, // статус відображення зміни ліміту
                checkAddBtn: false, // статус відображення кнопки "додати"
                checkMoreFilter: false, // статус відображення кнопки більше фільтрів
            },
            objPages: '',
            columns: [
                {
                    name: this.$t("Section"),
                    text: "whence",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item, obj) => this.mutateReviewsGroup(item).name,
                },
                {
                    name: this.$t("avgRating"),
                    text: "avgRating",
                    align: "left",
                    status: true,
                    copy: true,
                },
                {
                    name: this.$t("totalQuantReviews"),
                    text: "totalReviews",
                    align: "left",
                    status: true,
                    copy: true,
                },
            ],
            showCard: false,
            objCard: {},
            objParams: {
                page: '1',
                pagelimit: '10',
            },
            rows: [],
        }
    },
    components: {
        tablecustom,
        headerSection,
        filterSection,
        categoryCard
    },
    created() {
        this.getData()
    },
    methods: {
        changeMode(mode) {
            this.objFilter.defaultType = mode
        },
        getData(page) {
            this.objParams.page = page != undefined ? page : '1';
            apiServe.getSections(this.objParams, ['']).then(result => {
                if(result.status === 'done') {
                    this.rows = result.data.reviews
                    this.pages.total = result.data.total
                    this.objPages = result.data;
                    console.log(this.rows.length)
                } else {
                    
                }
            })
        },
        open(e) {
            this.$router.push({ 
                name: 'pages-list-open-reviewsFromClient', 
                params: { 
                    id: e.whence,
                    obj: e, 
                    mode: this.objFilter.checkChangeTab,
                } 
            })
        },
        handleError(error) {
            //відображення помилки
            switch(error){
                case 'condition':
                    this.$toast.error(this.t('translation_key'));
                    break;
            }
        },
        // змінити ліміт і оновити дані
        changelimit: function(limit){
            this.objParams.pagelimit = limit;
            this.getData();
        },
        mutateReviewsGroup(item, obj) {
            return mutateReviewsGroups(item)
        },
    },
    mounted(){
        if (storeS.perms[666]) {
            document.querySelector('#app').style.background = 'white';
        }

    },
}
</script>

<style>
</style>